import PropTypes from 'prop-types'

import { translate } from '@/utils/translations'

const CloseButton = ({ onClick }) => (
  <div className='button-wrap'>
    <button
      className='btn btn-primary'
      onClick={onClick}
      type='button'
    >
      {translate('common.okay')}
    </button>
  </div>
)

export default CloseButton

CloseButton.propTypes = { onClick: PropTypes.func.isRequired }
